import request from "@/utils/http";
import { PFX } from "../lsrm/constant/constant.js";

//LSP证件预警弹框接口
export const selectWarningDetail = params => {
    return request({
        url: `${PFX}/supplier/selectWarningDetail`,
        method: "get",
        params
    });
};

//取消LSP弹窗提醒
export const cancelLSPPopup = params => {
    return request({
        url: `${PFX}/supplier/cancelLSPPopup`,
        method: "get",
        params
    });
};

//绩效整改消息弹窗
export const lspRectificationPlanPopup = params => {
    return request({
        url: `${PFX}/supplier/lspRectificationPlanPopup`,
        method: "get",
        params
    });
};

//带申诉仲裁单提醒
export const selectDealTodoCountOrder = data => {
    return request({
        url: `/api-ams/public/ams/abnormal/front/selectDealTodoCountOrder`,
        method: "post",
        data
    });
};

// 根据供应商编码查询（需要再次提醒的）邀标信息
export const getBidSearchInfoInviteTip = params => {
    return request({
        url: `${PFX}/bid/bidSearchInfo/inviteTip`,
        method: 'get',
        params
    });
};

// 根据入参招标编码+供应商编码更新邀标信息
export const closeInviteTip = params => {
    return request({
        url: `${PFX}/bid/bidSearchInfo/closeInviteTip`,
        method: 'get',
        params
    });
};

// LSP银行账号预警弹框接口
export const supplierFinanceWarning = params => {
    return request({
        url: `${PFX}/supplier/supplierFinanceWarning/tips`,
        method: 'get',
    });
};

// 取消LSP银行账号弹窗提醒
export const noTips = params => {
    return request({
        url: `${PFX}/supplier/supplierFinanceWarning/noTips`,
        method: 'get',
        params,
    });
};
